<template>
  <div class="visit-success-page">
    <div class="title">
      Face Club COVID-19 Tracking
    </div>
    <div class="info" v-if="serverError">
      {{serverError}}
    </div>
  </div>
</template>

<script>

  import {verifyUser} from "../services/graphql";

  export default {
    name: "RegisterPage",
    props: {
      token:{
        type:String,
        required:true,
      }
    },
    data() {
      return {
        serverError: null,
      };
    },
    created() {
      verifyUser(this.token)
      .then((response) => {
        this.$router.push({
          name: "VisitSuccessPage"
        })
      }).catch((err) => {
        if(err.graphQLErrors && err.graphQLErrors[0].message) {
          this.serverError = err.graphQLErrors[0].message;
        }
      })
    }
  };
</script>

<style lang="scss">
  @import "VisitSuccessPage";
</style>
